import React from "react";
import Layout from "../components/layout"
import { getCurrentLocale, getTranslatedFields, getTranslatedValue } from "../helpers/fields";

class Record extends React.Component {

    onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }

    createSliderImages = (image, images) => {
        let elements = [];

        if (images === undefined && image === undefined) return;
        if (images === undefined) {
            images = [image];
        } else {
            images.unshift(image);
        }

        // filter out the unique images
        // so that repeated visits to this page do NOT
        // replicate the first image
        images = images.filter(this.onlyUnique);

        images.forEach((image) => {
            const element = (
                <figure className='child' key={image.url}>
                    <img src={image.url} alt={image.alt} />
                </figure>
            );

            if (image.url) {
                elements.push(element);
            }
        });

        return elements;
    };

    render() {
        const translatedFields = getTranslatedFields(this);
        const images = this.props.pageContext.data.fieldValues.images;
        const image = this.props.pageContext.data.fieldValues.image.nl_NL;

        const {
            history_note, webtext, title, creator_name, creator_dates,
            production_date, object_name, material, technique, dimension,
            inscription, inscription_type, location_name, object_number,
            audio, video
        } = translatedFields;

        const translations = this.props.pageContext.translations;
        const includeMissingLocaleWarning = this.props.pageContext.data.fieldValues.title[getCurrentLocale(this)] === undefined;

        const sliderImages = this.createSliderImages(image, images);
        return (
            <Layout lang={getCurrentLocale(this)} title={title} translations={translations} includeMissingLocaleWarning={includeMissingLocaleWarning}
                className='kunstwerken kunstwerkdetail' page={this}>
                <div className="slider">
                    {sliderImages}

                    {sliderImages.length > 1 &&
                        <div className="attention">
                            <object>
                                <svg height="30" viewBox="0 0 28 30" width="28" xmlns="http://www.w3.org/2000/svg"><g fill="#fff"><path d="m7.65830632 14.2361381c-1.0029107.9155346-1.65830621 2.0608119-1.65830621 3.2838816v1.4891358c0 1.6557618 1.77071564 4.3768012 2.07703796 4.8716168.50017151.8079487 1.33977112 2.0204121 2.02668603 2.92413.1680257.2210579.4823209.2597667.7011781.0913739s.2593443-.479807.0913739-.7011781c-.5409904-.7129811-1.54156378-2.1627883-1.97331395-2.8476291-.29786673-.4724753-1.92296204-3.0283159-1.92296204-4.3383135v-1.4891358c0-.8975663.49554599-1.7617673 1.34169379-2.5538258.14952822-.1399698.39977988-.3480051.65830621-.5435227l.0020334 3.077329c0 .2799988.22796614.5.4979666.5.27999973 0 .50203329-.173463.50203339-.5v-11.50000004c0-.55228475.4477152-1 1-1 .5522847 0 1 .44771525 1 1v8.50000004c0 .2761424.2238576.5.5.5s.5-.2238576.5-.5v-2.5c0-.5522847.4477152-1 1-1 .5522847 0 1 .4477153 1 1v2.5c0 .2761424.2238576.5.5.5s.5-.2238576.5-.5v-1.5c0-.5522847.4477152-1 1-1 .5522847 0 1 .4477153 1 1v2.5c0 .2761424.2238576.5.5.5s.5-.2238576.5-.5v-1.5c0-.5522847.4477152-1 1-1 .5522847 0 1 .4477153 1 1v3.5c-.0000002 3.2747192-2.0000002 6.3953247-2 9 0 .2761424.2238576.5.5.5s.5-.2238576.5-.5c-.0000002-2.2444458 2-5.7125854 2-9v-3.5c0-1.1045695-.8954305-2-2-2-.4116588 0-.7942691.1243714-1.1123052.3375886-.2733526-.7790169-1.015293-1.3375886-1.8876948-1.3375886-.4116588 0-.7942691.1243714-1.1123052.3375886-.2733526-.7790169-1.015293-1.3375886-1.8876948-1.3375886-.3642871 0-.7058266.0973943-1 .2675644v-4.26756444c0-1.1045695-.8954305-2-2-2-1.10456949 0-1.99999999.8954305-1.99999999 2v7.21023344c-.49451441.2980073-.98957051.7026028-1.34372719 1.0259045z" transform="matrix(.80901699 -.58778525 .58778525 .80901699 -6.436918 11.189894)" /><path d="m15.6464466 5.64644661c.1952622-.19526215.5118446-.19526215.7071068 0 .1952621.19526215.1952621.51184463 0 .70710678l-2 2c-.1952622.19526215-.5118446.19526215-.7071068 0l-2-2c-.1952621-.19526215-.1952621-.51184463 0-.70710678.1952622-.19526215.5118446-.19526215.7071068 0l1.1464466 1.14644661v-9.79289322c0-.27614237.2238576-.5.5-.5s.5.22385763.5.5v9.79574587z" transform="matrix(0 1 -1 0 16.5 -11.5)" /></g></svg>
                            </object>
                        </div>
                    }
                </div>
                <h3>{title}</h3>
                <h4>{creator_name}<br/>
                    {production_date}</h4>
                <p className="meta">{object_number} - {location_name}</p>

                {audio && audio.url &&
                    <audio controls>
                        <source src={audio.url} type="audio/mpeg" />
                        Your browser does not support the audio element.
                    </audio>
                }

                {video && video.url &&
                    <div className="video-wrapper">
                        <div dangerouslySetInnerHTML={{ __html: video.responsive_inline }} />
                    </div>
                }

                <div dangerouslySetInnerHTML={{ __html: webtext }} />

                <p className="details">
                    {technique} {getTranslatedValue(this, translations.on)} {material}<br/>
                    {dimension}<br/>
                    {history_note}<br/>
                </p>
            </Layout>
        );
    }
}

export default Record;